/**
 * @file planConstants.js
 * @module ui/src/constants/planConstants
 * @description
 *   Shared plan domain constants used across plan authoring components.
 *
 *   Extracted S931 (OI-S913-PCMA-MATRIX-DUPLICATE): PCMA_MATRIX previously
 *   duplicated in PlanDocumentCanvas.jsx and PayoutAdjustmentsSection.jsx.
 *   Single source of truth here prevents sync failures on future updates.
 *
 * PCMA_MATRIX — frontend constant (arch spec §4.3 — never a server call)
 *   Channel is Layer 0 only (D12). Keys match plan.primarySpine values.
 *   S913: 'mbo' added to all spines where MBO secondary measure is applicable.
 *   S929: 'nps' and 'adoption' added to same spines as 'mbo' (G-17/G-18).
 *     ARR, MBO, NPS, Adoption are co-located secondary measures on the same spine.
 *   Excluded: bonus_pool only — pool allocation is inherently discretionary;
 *   MBO/NPS/Adoption on top of a bonus pool is architecturally redundant.
 *   Must be kept in sync with MODIFIERS array keys in PayoutAdjustmentsSection.
 */

export const PCMA_MATRIX = Object.freeze({
  revenue_bookings:       ['kicker','cap','draw_guarantee','clawback','rev_type_differentials','spiff','contest','non_cash','multi_year_deal','mbo','nps','adoption'],
  transaction_commission: ['cap','clawback','spiff','contest','non_cash','mbo','nps','adoption'],
  volume_quantity:        ['kicker','cap','draw_guarantee','clawback','contest','non_cash','mbo','nps','adoption'],
  market_share:           ['kicker','cap','contest','non_cash','mbo','nps','adoption'],
  grr_nrr_retention:      ['clawback','draw_guarantee','non_cash','mbo','nps','adoption'],
  mbo_objective:          ['non_cash','contest','mbo','nps','adoption'],
  margin_profit:          ['kicker','cap','clawback','mbo','nps','adoption'],
  bonus_pool:             ['non_cash'],
  pharma_script:          ['kicker','cap','contest','mbo','nps','adoption'],
});
